import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Footer, DisclaimerBar } from '../components/Chrome';
import { useI18n } from '../i18n';

export default function PaymentCancel() {
  const { lang } = useI18n();
  return (
    <div>
      <Nav />
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div className="mono text-[10px] uppercase tracking-widest2 text-red-400">
          {lang === 'es' ? 'PAGO CANCELADO' : 'PAYMENT CANCELED'}
        </div>
        <h1 className="serif text-5xl md:text-6xl mt-6">
          {lang === 'es' ? 'Sin cargo aplicado.' : 'No charge was made.'}
        </h1>
        <p className="mt-6 text-white/70 max-w-xl mx-auto">
          {lang === 'es'
            ? 'Tu intake fue registrado. Cuando quieras completar el pago, escríbenos y te enviamos el link.'
            : 'Your intake is on file. When you want to complete payment, message us and we will resend the link.'}
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/intake" className="mono text-[11px] uppercase tracking-widest2 bg-gold text-obsidian px-6 py-3 hover:bg-white" style={{transitionProperty: 'background-color'}}>
            {lang === 'es' ? '← Volver al intake' : '← Back to intake'}
          </Link>
          <Link to="/contact" className="mono text-[11px] uppercase tracking-widest2 border hairline px-6 py-3 hover:border-gold hover:text-gold" style={{transitionProperty: 'color, border-color'}}>
            {lang === 'es' ? 'Contactar equipo' : 'Contact team'}
          </Link>
        </div>
      </div>
      <DisclaimerBar />
      <Footer />
    </div>
  );
}
